import i18n from '~/locales/i18n';

i18n.addResourceBundle('en', 'app', {
  addBalance: 'Add Balance',
  addBalanceNow: 'Add Balance Now',
  noTransactionsFound: 'No transactions',
  addedBalance: 'Balance added ',
  balanceDeducted: 'Balance Deducted',
  currentBalance: 'Current balance available to use',
  allTime: 'All Time',
  lastDay: 'Last Day',
  lastWeek: 'Last Week',
  lastMonth: 'Last Month',
  customDate: 'Custom Date',
  filterResultsByDate: 'filter results by date',
  all: 'All',
  payments: 'Payments',
  topUps: 'Top-ups',
  balanceValue: 'Balance Value',
  priceWithVat: 'Price with VAT:  ',
  paymentSummary: 'Payment Summary',
  editSearchCriteria: 'Edit search criteria or add new transactions',
  topupSummary: 'Top-up Summary',
  topupDetails: 'Top-up Details',
});
